import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { categories } from '../../mocks/categories';

const ProductsPage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <p className="text-sm text-warmGray mb-4">ÜRÜNLER</p>
            <h1 className="text-5xl md:text-6xl font-display font-bold text-navy mb-6">
              Montessori Mobilya Koleksiyonumuz
            </h1>
            <p className="text-lg text-warmGray leading-relaxed">
              Anaokulları ve oyun alanları için özel tasarlanmış, güvenli ve estetik mobilyalar
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-product-shop>
            {categories.map((category) => (
              <Link key={category.id} to={`/kategori/${category.slug}`} className="group cursor-pointer">
                <div className="relative h-[400px] rounded-2xl overflow-hidden mb-4">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="inline-block px-4 py-1.5 bg-mint rounded-full text-sm text-navy font-medium mb-3">
                  Kategori
                </div>
                <h3 className="text-2xl font-semibold text-navy group-hover:text-coral transition-colors">
                  {category.name}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsPage;
